import {
  parse,
  truncateByMonth,
  getDiffInMonth,
  format,
  shiftByMonthAmount
} from '@/utils/date'

class ContractChartView {
  constructor(contract) {
    this.id = contract.id
    this.name = contract.email
    this.startDate = contract.startDate
    this.contractValue = contract.contractValue
    this.endDate = contract.endDate
    this.valuesByDate = this.prepareValuesByDate(contract)
  }

  setName(name) {
    this.name = name
  }

  merge(chartView) {
    const sortedViews = [this, chartView].sort((a, b) =>
      a.endDate.localeCompare(b.endDate)
    )
    this.endDate = sortedViews[1].endDate
    this.contractValue += chartView.contractValue
    this.valuesByDate = sortedViews.reduce(
      (acc, cur) => ({ ...acc, ...cur.valuesByDate }),
      {}
    )
  }
  concat(chartView) {
    this.endDate =
      this.endDate > chartView.endDate ? this.endDate : chartView.endDate
    this.startDate =
      this.startDate < chartView.startDate
        ? this.startDate
        : chartView.startDate
    this.contractValue += chartView.contractValue
    Object.keys(chartView.valuesByDate).forEach((date) => {
      if (!this.valuesByDate[date]) this.valuesByDate[date] = 0
      this.valuesByDate[date] += chartView.valuesByDate[date]
    })
  }

  getValueByDate(date) {
    return this.valuesByDate[format(truncateByMonth(date))] || 0
  }

  prepareValuesByDate(contract) {
    if (contract.contractType === 'year')
      return {
        [format(truncateByMonth(contract.startDate))]: contract.contractValue
      }
    const valuesByDate = {}
    const from = contract.startDate
    const to = contract.endDate
    const diffInMonth = getDiffInMonth(from, to)
    const indexes = [...Array(diffInMonth + 1).keys()]
    const valueByMonth = contract.contractValue / diffInMonth
    indexes.forEach((index) => {
      let date = shiftByMonthAmount(from, index)
      date = truncateByMonth(parse(date))
      valuesByDate[format(date)] = valueByMonth
    })
    return valuesByDate
  }
}

export function createContractChartView(contract) {
  return new ContractChartView(contract)
}
